import {
  Grid,
  TextField,
  FormHelperText,
  Box,
  useTheme,
  Button,
  Typography,
} from "@mui/material";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import Header from "../../components/Header";
import { tokens } from "../../theme";

const DiscourseDetails = ({
  onHandleDiscourseDetailsInputChange,
  discourseDetails,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const colors = tokens(theme.palette.mode);

  const gotoPreviousPage = () => {
    navigate("/token-gating");
  };

  return (
    <Box m="40px" ml="60px">
      <Header title="Discourse Details" subtitle="Fill the required field" />
      <Grid container spacing={3}>
        <Grid item xs={6} md={6}>
          <TextField
            name="forumLink"
            label="Enter the discourse forum link "
            variant="outlined"
            type="text"
            fullWidth
            sx={{ mt: 1, boxShadow: 2 }}
            value={discourseDetails.forumLink}
            onChange={onHandleDiscourseDetailsInputChange}
            required
          />
        </Grid>
        <Grid item xs={6} md={6}>
          <TextField
            name="discourseConnectSecret"
            label="Enter the Discourse Connect Secret "
            variant="outlined"
            type="text"
            fullWidth
            sx={{ mt: 1, boxShadow: 2 }}
            value={discourseDetails.discourseConnectSecret}
            onChange={onHandleDiscourseDetailsInputChange}
            required
          />
        </Grid>
        <Grid item xs={6} md={6}>
          <TextField
            name="customerKeyForOTPVerification"
            label="Enter the customer key for OTP Verification "
            variant="outlined"
            type="text"
            fullWidth
            sx={{ mt: 1, boxShadow: 2 }}
            value={discourseDetails.customerKeyForOTPVerification}
            onChange={onHandleDiscourseDetailsInputChange}
            required
          />
        </Grid>
        <Grid item xs={6} md={6}>
          <TextField
            name="customerAPIKeyForOTPVerification"
            label="Enter the customer API Key for OTP Verification "
            variant="outlined"
            type="text"
            fullWidth
            sx={{ mt: 1, boxShadow: 2 }}
            value={discourseDetails.customerAPIKeyForOTPVerification}
            onChange={onHandleDiscourseDetailsInputChange}
            required
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DiscourseDetails;
